
import { debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { IS_MASTER, config } from "config";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { StoreError } from "./StoreError";
import { StoreImageTest } from "./StoreImageTest";
import { StoreLandingPage } from "./StoreLandingPage";
import { StoreRoutes } from "./StoreRoutes";
import { StoreStore } from "./StoreStore";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class StoreContainer extends React.Component<IProps, {}> {
    store: StoreStore;

    constructor(props: any) {
        super(props);
        this.store = new StoreStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized) {
                await this.store.load();
            }
            if (config.network.environmentIsFat) {
                document.cookie = "gemletmetesttoken=qH1iX2fP7wI1vT5qG3zD4iR7yL2iR7bI;domain=.sparkasse.at;path=/";
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            pushRoute("/store/error");
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("store.document.title");

        return (
            <div>
                <Route exact path={StoreRoutes.ROOT} render={this.withStore(StoreLandingPage)} />
                {!IS_MASTER &&
                    <Route path={StoreRoutes.IMAGE_TEST} render={this.withStore(StoreImageTest)} />
                }
                <Route path={StoreRoutes.ERROR} component={StoreError} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/store/StoreContainer.tsx